export class TypeformWorkspaceHref {
    constructor(
        public href: string,
    ) {}

    static fromData(data: any): TypeformWorkspaceHref {
        if (data === null || typeof data === 'string' || data instanceof TypeformWorkspaceHref) {
            return data
        }

        return new TypeformWorkspaceHref(
            data.href,
        )
    }
}
